export const normalizeHref = (rawHref) => {
  const href = String(rawHref ?? '').trim().replace(/^"+|"+$/g, '');
  if (!href || href.toLowerCase() === 'none') return '';
  if (/^https?:\/\//i.test(href)) return href;
  if (href.startsWith('/')) return href;
  return `https://${href}`;
};
